import React from 'react';

import { containerChildProps } from 'common/constants/sharedPropTypes';
import PropTypes from 'prop-types';

const SelectedTimestamp = ({ parent, timestamp }) => {
  const { height, clip, scale } = parent;

  return (
    <line
      y1={0}
      y2={height}
      strokeWidth={1}
      clipPath={clip}
      x1={scale && scale(new Date(timestamp))}
      x2={scale && scale(new Date(timestamp))}
      stroke="black"
    />
  );
};

SelectedTimestamp.propTypes = {
  timestamp: PropTypes.string,
  parent: containerChildProps,
};

export default SelectedTimestamp;
